import { render, staticRenderFns } from "./AlarmCenterMonitorListDyw.vue?vue&type=template&id=2a790ea4&scoped=true"
import script from "./AlarmCenterMonitorListDyw.vue?vue&type=script&lang=js"
export * from "./AlarmCenterMonitorListDyw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a790ea4",
  null
  
)

export default component.exports